/******************************************************************************/
/* Gift Box Delivery Logic - Zapiet */
/*
 * Gift Box and Gift Wag Bags only:
 * - Automatically select Store Pickup
 * - Disable Local Delivery
 *
 * Gift Box with any normal product:
 * - Re-enable Local Delivery
 */
/******************************************************************************/

(function () {
  const GIFT_BOX_HANDLE = 'gift-box';

  const GIFT_WAG_HANDLES = [
    'gift-box-cheezies-wag-bag',
    'gift-box-bark-kwa-pork-wag-bag',
    'gift-box-bark-kwa-beef-wag-bag',
    'gift-box-something-fishy-wag-bag'
  ];

  let giftOnlyCart = false;
  let isReadingCart = false;
  let cartCheckTimer = null;

  function isCartPage() {
    return (
      window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart/')
    );
  }

  function getItemHandle(item) {
    return String(
      item.handle ||
      item.product_handle ||
      ''
    ).toLowerCase();
  }

  function isMainGiftBox(item) {
    const handle = getItemHandle(item);
    const title = String(
      item.product_title ||
      item.title ||
      ''
    ).toLowerCase();

    return (
      handle === GIFT_BOX_HANDLE ||
      title.includes('the barkaneers gift box') ||
      Boolean(
        item.properties &&
        item.properties['_Birthday Gift Box'] === 'Yes'
      )
    );
  }

  function isGiftWagBag(item) {
    const handle = getItemHandle(item);
    const title = String(
      item.product_title ||
      item.title ||
      ''
    ).toLowerCase();

    return (
      GIFT_WAG_HANDLES.includes(handle) ||
      title.startsWith('gift box ') ||
      Boolean(
        item.properties &&
        item.properties['_Gift Box Add-on'] === 'Yes'
      )
    );
  }

  function isGiftBundleItem(item) {
    return isMainGiftBox(item) || isGiftWagBag(item);
  }

  function getZapietMethods() {
    const methodCards = Array.from(
      document.querySelectorAll(
        '#storePickupApp .checkoutMethod'
      )
    );

    let deliveryCard = null;
    let pickupCard = null;

    methodCards.forEach(function (card) {
      const nameElement = card.querySelector(
        '.checkoutMethodName'
      );

      if (!nameElement) return;

      const methodName = nameElement.textContent
        .trim()
        .toLowerCase();

      if (methodName === 'local delivery') {
        deliveryCard = card;
      }

      if (
        methodName === 'store pickup' ||
        methodName === 'pickup'
      ) {
        pickupCard = card;
      }
    });

    return {
      deliveryCard: deliveryCard,
      pickupCard: pickupCard
    };
  }

  function removeOldBrokenMessage() {
    document.querySelectorAll(
      '#gift-box-delivery-restriction-message'
    ).forEach(function (element) {
      element.remove();
    });
  }

  function addDeliveryMessage() {
    const storePickupApp =
      document.getElementById('storePickupApp');

    if (!storePickupApp) return;

    let message = document.getElementById(
      'gift-box-delivery-message'
    );

    if (message) return;

    message = document.createElement('p');
    message.id = 'gift-box-delivery-message';
    message.className = 'gift-box-delivery-message';

    message.textContent =
      'The Birthday Gift Box is available for Store Pickup only. Add another regular product to enable Local Delivery.';

    const methodsContainer = storePickupApp.querySelector(
      '.checkoutMethodsContainer'
    );

    if (methodsContainer) {
      methodsContainer.insertAdjacentElement(
        'afterend',
        message
      );
    } else {
      storePickupApp.appendChild(message);
    }
  }

  function removeDeliveryMessage() {
    const message = document.getElementById(
      'gift-box-delivery-message'
    );

    if (message) {
      message.remove();
    }
  }

  function selectPickup(pickupCard) {
    if (!pickupCard) return;

    if (!pickupCard.classList.contains('active')) {
      pickupCard.click();
    }
  }

  function disableDeliveryCard(deliveryCard) {
    if (!deliveryCard) return;

    deliveryCard.classList.add(
      'gift-box-delivery-disabled'
    );

    deliveryCard.setAttribute(
      'aria-disabled',
      'true'
    );

    deliveryCard.setAttribute(
      'data-gift-delivery-disabled',
      'true'
    );

    addDeliveryMessage();
  }

  function enableDeliveryCard(deliveryCard) {
    if (!deliveryCard) return;

    deliveryCard.classList.remove(
      'gift-box-delivery-disabled'
    );

    deliveryCard.removeAttribute('aria-disabled');
    deliveryCard.removeAttribute(
      'data-gift-delivery-disabled'
    );

    removeDeliveryMessage();
  }

  function updateZapietMethods() {
    if (!isCartPage()) return;

    removeOldBrokenMessage();

    const methods = getZapietMethods();

    if (!methods.deliveryCard && !methods.pickupCard) {
      return;
    }

    if (giftOnlyCart) {
      /*
       * Select Pickup first.
       */
      selectPickup(methods.pickupCard);

      /*
       * Then disable only the Local Delivery card.
       */
      disableDeliveryCard(methods.deliveryCard);
    } else {
      enableDeliveryCard(methods.deliveryCard);
    }
  }

  async function checkCart() {
    if (!isCartPage() || isReadingCart) return;

    isReadingCart = true;

    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Unable to read cart.');
      }

      const cart = await response.json();

      const hasGiftBox = cart.items.some(
        isMainGiftBox
      );

      const hasNormalProduct = cart.items.some(
        function (item) {
          return !isGiftBundleItem(item);
        }
      );

      giftOnlyCart =
        hasGiftBox &&
        !hasNormalProduct;

      document.documentElement.classList.toggle(
        'gift-box-only-cart',
        giftOnlyCart
      );

      updateZapietMethods();

      console.log(
        '[Gift Box Delivery]',
        {
          giftOnlyCart: giftOnlyCart,
          hasGiftBox: hasGiftBox,
          hasNormalProduct: hasNormalProduct
        }
      );
    } catch (error) {
      console.error(
        '[Gift Box Delivery Error]',
        error
      );
    } finally {
      isReadingCart = false;
    }
  }

  function scheduleCartCheck() {
    clearTimeout(cartCheckTimer);

    cartCheckTimer = setTimeout(function () {
      checkCart();
      updateZapietMethods();
    }, 300);
  }

  /*
   * Block Local Delivery clicks only when
   * the cart contains the Gift Box bundle alone.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!giftOnlyCart) return;

      const deliveryCard = event.target.closest(
        '#storePickupApp .checkoutMethod'
      );

      if (!deliveryCard) return;

      const methodNameElement =
        deliveryCard.querySelector(
          '.checkoutMethodName'
        );

      if (!methodNameElement) return;

      const methodName =
        methodNameElement.textContent
          .trim()
          .toLowerCase();

      if (methodName !== 'local delivery') {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const methods = getZapietMethods();

      selectPickup(methods.pickupCard);
      disableDeliveryCard(methods.deliveryCard);
    },
    true
  );

  document.addEventListener(
    'DOMContentLoaded',
    scheduleCartCheck
  );

  window.addEventListener(
    'load',
    scheduleCartCheck
  );

  document.addEventListener(
    'cart:updated',
    scheduleCartCheck
  );

  document.addEventListener(
    'cart:refresh',
    scheduleCartCheck
  );

  /*
   * Zapiet's actual available event from your page.
   */
  if (
    window.ZapietEvent &&
    typeof window.ZapietEvent.listen === 'function'
  ) {
    window.ZapietEvent.listen(
      'widget_loaded',
      function () {
        scheduleCartCheck();
      }
    );
  }

  const observer = new MutationObserver(
    function () {
      if (!isCartPage()) return;

      updateZapietMethods();
    }
  );

  function startObserver() {
    if (!document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );
  } else {
    startObserver();
  }

  scheduleCartCheck();
})();



/******************************************************************************/
/*********************** Gift Box Wag Bags Cart Logic *************************/
/******************************************************************************/

(function () {
  'use strict';

  const GIFT_BOX_PRODUCT_NAME =
    'the barkaneers gift box';

  const GIFT_WAG_BAG_NAMES = [
    'gift box cheezies wag bag',
    'gift box bark-kwa pork wag bag',
    'gift box bark-kwa beef wag bag',
    'gift box something fishy wag bag'
  ];

  let isGiftCleaning = false;

  function isCartPage() {
    return (
      window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart/')
    );
  }

  function isGiftBoxItem(item) {
    return Boolean(
      item &&
      item.properties &&
      item.properties['_Birthday Gift Box'] === 'Yes'
    );
  }

  function isGiftBoxWagBagItem(item) {
    return Boolean(
      item &&
      item.properties &&
      item.properties['_Gift Box Add-on'] === 'Yes'
    );
  }

  function getGiftBundleId(item) {
    if (
      !item ||
      !item.properties ||
      !item.properties['_Gift Box Bundle ID']
    ) {
      return '';
    }

    return String(
      item.properties['_Gift Box Bundle ID']
    );
  }

  function isGiftBoxRow(row) {
    if (!row) return false;

    const text = String(
      row.innerText || ''
    ).toLowerCase();

    return (
      text.includes(GIFT_BOX_PRODUCT_NAME) ||
      GIFT_WAG_BAG_NAMES.some(function (name) {
        return text.includes(name);
      })
    );
  }

  function getCartRows() {
    return Array.from(
      document.querySelectorAll(
        'tr.cart-item, .cart-item, .cart__row'
      )
    );
  }

  function hideGiftBoxQuantityAndPrice() {
  if (!isCartPage()) return;

  getCartRows().forEach(function (row) {
    if (!isGiftBoxRow(row)) return;

    /*
     * Hide quantity controls only.
     * Do NOT hide .cart-item__quantity-wrapper
     * because the remove/delete button is inside it.
     */
    row.querySelectorAll(
      [
        '.quantity-popover-container',
        'quantity-input',
        '.quantity'
      ].join(',')
    ).forEach(function (element) {
      element.style.setProperty(
        'display',
        'none',
        'important'
      );
    });

    /*
     * Make sure remove/delete button stays visible.
     */
    row.querySelectorAll(
      'cart-remove-button, cart-remove-button a'
    ).forEach(function (element) {
      element.style.setProperty(
        'display',
        '',
        'important'
      );

      element.style.setProperty(
        'visibility',
        'visible',
        'important'
      );

      element.style.setProperty(
        'opacity',
        '1',
        'important'
      );

      element.style.setProperty(
        'pointer-events',
        'auto',
        'important'
      );
    });

    /*
     * Hide price/total only.
     */
    row.querySelectorAll(
      [
        '.cart-item__price-wrapper',
        '.cart-item__totals',
        '.cart__price'
      ].join(',')
    ).forEach(function (element) {
      element.style.setProperty(
        'display',
        'none',
        'important'
      );
    });
  });
}

  function getRemoveButton(target) {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(
      [
        'cart-remove-button',
        'cart-remove-button a',
        'a[href*="/cart/change"]'
      ].join(',')
    );
  }

  function getRemoveLink(removeButton) {
    if (!removeButton) return null;

    if (
      removeButton.tagName === 'A' &&
      removeButton.getAttribute('href')
    ) {
      return removeButton;
    }

    return removeButton.querySelector(
      'a[href*="/cart/change"]'
    );
  }

  function getTargetItem(
    removeButton,
    cart,
    cartRow
  ) {
    const removeWrapper =
      removeButton.matches('cart-remove-button')
        ? removeButton
        : removeButton.closest(
            'cart-remove-button'
          );

    /*
     * Dawn normally adds data-index to
     * cart-remove-button.
     */
    if (removeWrapper) {
      const dataIndex = Number(
        removeWrapper.getAttribute(
          'data-index'
        ) || 0
      );

      if (
        dataIndex > 0 &&
        cart.items[dataIndex - 1]
      ) {
        return cart.items[dataIndex - 1];
      }
    }

    const removeLink =
      getRemoveLink(removeButton);

    const href = removeLink
      ? removeLink.getAttribute('href') || ''
      : '';

    /*
     * Try line number.
     */
    const lineMatch = href.match(
      /[?&]line=([^&]+)/
    );

    if (lineMatch && lineMatch[1]) {
      const lineIndex =
        Number(lineMatch[1]) - 1;

      if (cart.items[lineIndex]) {
        return cart.items[lineIndex];
      }
    }

    /*
     * Try cart item key.
     */
    const idMatch = href.match(
      /[?&]id=([^&]+)/
    );

    if (idMatch && idMatch[1]) {
      const itemKey = decodeURIComponent(
        idMatch[1]
      );

      const matchingItem =
        cart.items.find(function (item) {
          return item.key === itemKey;
        });

      if (matchingItem) {
        return matchingItem;
      }
    }

    /*
     * Final fallback: match cart row position.
     */
    const rows = getCartRows();
    const rowIndex = rows.indexOf(cartRow);

    if (
      rowIndex >= 0 &&
      cart.items[rowIndex]
    ) {
      return cart.items[rowIndex];
    }

    return null;
  }

  async function readCart() {
    const response = await fetch(
      '/cart.js?gift_remove=' + Date.now(),
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to read the cart.'
      );
    }

    return response.json();
  }

  async function removeCartItems(updates) {
    const response = await fetch(
      '/cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to update the cart.'
      );
    }

    return response.json();
  }

  async function processGiftRemoval(
    removeButton,
    cartRow
  ) {
    if (isGiftCleaning) return;

    isGiftCleaning = true;

    try {
      const cart = await readCart();

      const targetItem = getTargetItem(
        removeButton,
        cart,
        cartRow
      );

      if (!targetItem) {
        throw new Error(
          'Cart item could not be found.'
        );
      }

      const targetIsGiftBox =
        isGiftBoxItem(targetItem);

      const targetIsWagBag =
        isGiftBoxWagBagItem(targetItem);

      if (
        !targetIsGiftBox &&
        !targetIsWagBag
      ) {
        isGiftCleaning = false;
        return;
      }

      const updates = {};

      /*
       * Always remove the clicked item.
       */
      updates[targetItem.key] = 0;

      /*
       * When main Gift Box is removed,
       * remove all linked Wag Bags with
       * the same Gift Box Bundle ID.
       */
      if (targetIsGiftBox) {
        const giftBundleId =
          getGiftBundleId(targetItem);

        cart.items.forEach(function (item) {
          if (!isGiftBoxWagBagItem(item)) {
            return;
          }

          const wagBundleId =
            getGiftBundleId(item);

          if (
            giftBundleId &&
            wagBundleId === giftBundleId
          ) {
            updates[item.key] = 0;
          }
        });
      }

      await removeCartItems(updates);

      /*
       * Normal cart reload after successful update.
       * The existing Zapiet code will run again and
       * correctly refresh Local Delivery/Store Pickup.
       */
      window.location.href = '/cart';
    } catch (error) {
      console.error(
        '[Gift Box Removal Error]',
        error
      );

      isGiftCleaning = false;
      window.location.reload();
    }
  }

  function handleGiftRemoveClick(event) {
    if (
      !isCartPage() ||
      isGiftCleaning
    ) {
      return;
    }

    const removeButton =
      getRemoveButton(event.target);

    if (!removeButton) return;

    const cartRow = removeButton.closest(
      'tr.cart-item, .cart-item, .cart__row'
    );

    /*
     * Do not touch normal cart products.
     */
    if (!isGiftBoxRow(cartRow)) {
      return;
    }

    /*
     * Stop Shopify's original delete action
     * immediately, before fetching /cart.js.
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    processGiftRemoval(
      removeButton,
      cartRow
    );
  }

  document.addEventListener(
    'click',
    handleGiftRemoveClick,
    true
  );

  document.addEventListener(
    'DOMContentLoaded',
    hideGiftBoxQuantityAndPrice
  );

  window.addEventListener(
    'load',
    hideGiftBoxQuantityAndPrice
  );

  document.addEventListener(
    'cart:updated',
    hideGiftBoxQuantityAndPrice
  );

  document.addEventListener(
    'cart:refresh',
    hideGiftBoxQuantityAndPrice
  );

  const giftObserver =
    new MutationObserver(function () {
      hideGiftBoxQuantityAndPrice();
    });

  function startGiftObserver() {
    if (!document.body) return;

    giftObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startGiftObserver
    );
  } else {
    startGiftObserver();
    hideGiftBoxQuantityAndPrice();
  }
})();

